<template>
	<div class="pic">
		<!-- 主内容区域 -->
		<div class="img-body">
			<img v-lazy="bigImgs[activeIndex]" class="frame" @click="openLightbox(activeIndex)">
		</div>
		<div class="frame-2">
			<div class="carousel-track" :style="{ transform: `translateX(${offsetX + dragOffset}px)` }"
				@mousedown="startDrag" @touchstart="startDrag" @mousemove="onDrag" @touchmove="onDrag"
				@mouseup="endDrag" @mouseleave="endDrag" @touchend="endDrag">
				<div class="img-block" v-for="(image, index) in images" :key="index"
					:class="{ 'active': activeIndex === index }" @click="setActiveIndex(index)">
					<img v-lazy="image" @click.stop="openLightbox(index)">
				</div>
			</div>
		</div>
		<div class="auto-wrapper">
			<div class="frame-6">
				<div class="frame-7">
					<div class="fixed-btn" @click="$router.go(-1)">
						<img :src="require(`@/assets/arrow.png`)">
					</div>
					<img :src="require(`@/assets/pic_img_1.png`)" class="frame-8">
				</div>
				<div class="frame-9">
					<div class="auto-wrapper-1">
						<img :src="require(`@/assets/arrow.png`)" class="polygon polygon-1" @click="slideRight"
							:class="{ 'disabled': isAtStart }">
						<img :src="require(`@/assets/arrow.png`)" class="polygon polygon-2" @click="slideLeft"
							:class="{ 'disabled': isAtEnd }">
					</div>
					<div class="frame-11">
						<div class="auto-wrapper-2">
							<p class="text">设</p>
							<p class="d-esign">DESIGN</p>
						</div>
						<p class="text-2">计</p>
					</div>
				</div>
			</div>
		</div>

		<!-- 全屏图片查看器 -->
		<div class="lightbox" v-if="showLightbox">
			<!-- 将按钮移到图片外层 -->
			<button class="lightbox-close" @click="closeLightbox">×</button>
			<button class="lightbox-nav lightbox-prev" @click.stop="prevImage" :disabled="lightboxIndex === 0">
				<img :src="require(`@/assets/arrow.png`)" class="nav-arrow">
			</button>
			<button class="lightbox-nav lightbox-next" @click.stop="nextImage"
				:disabled="lightboxIndex === images.length - 1">
				<img :src="require(`@/assets/arrow.png`)" class="nav-arrow">
			</button>

			<div class="lightbox-content" @click.self="closeLightbox">
				<img v-lazy="bigImgs[lightboxIndex]" class="lightbox-image" @click.stop>
			</div>
			<div class="lightbox-tip" v-if="isMobile">
				<div>1.上下划不动？可以试试左右滑动</div>
				<div>2.图片加载太慢？国外托管,耐心等待片刻</div>
				<div>3.图片有纹理？防盗水印导致</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeIndex: 0,
				currentPosition: 0,
				itemWidth: 230, // 图片宽度 + 边距
				visibleItems: 3, // 可见图片数量:pc3，手机2
				isDragging: false,
				startX: 0,
				dragOffset: 0,
				lastDragOffset: 0,
				velocity: 0,
				lastTime: 0,
				animationId: null,
				showLightbox: false,
				lightboxIndex: 0,
				images: [],
				bigImgs: []
			};
		},
		computed: {
			offsetX() {
				return -this.currentPosition * this.itemWidth;
			},
			isAtStart() {
				return this.currentPosition <= 0;
			},
			isAtEnd() {
				return this.currentPosition >= this.images.length - this.visibleItems;
			},
			// 是否是手机端
			isMobile() {
			    return window.innerWidth < 768; // 通常768px是移动和桌面的分界点
			}
		},
		mounted() {
			this.visibleItems = this.isMobile ? 3 : 3 // 可见图片数量:pc3，手机2
			this.itemWidth = this.isMobile ? 120 : 230
			// 默认页面水平滚动到右边（适配手机端）
			window.scrollTo({
			  left: document.body.scrollWidth,
			  behavior: 'auto' // 可选，平滑滚动
			});

			window.addEventListener('keydown', this.handleKeydown);
			
			let srcPre = process.env.NODE_ENV === 'development' ? './static' : './static'
			// 获取所有图片路径require
			let files = require.context('../../../static/smPicImgs', false, /.(png|jpg|JPG|jpeg|gif|bmp|webp)$/).keys()
			
			files.forEach(item => {
			  let name = item.substr(2,item.length)
			  this.images.push(`${srcPre}/smPicImgs/${name}`)
			});

			let bigFiles = require.context('../../../static/picImgs', false, /.(png|jpg|JPG|jpeg|gif|bmp|webp)$/).keys()

			bigFiles.forEach(item => {
			  let name = item.substr(2,item.length)
			  this.bigImgs.push(`${srcPre}/picImgs/${name}`)
			})
		},
		beforeDestroy() {
			cancelAnimationFrame(this.animationId);
			window.removeEventListener('keydown', this.handleKeydown);
			document.body.style.overflow = ''; // 确保组件销毁时恢复滚动
		},
		methods: {
			setActiveIndex(index) {
				this.activeIndex = index;
				if (index > this.currentPosition + this.visibleItems - 1) {
					this.currentPosition = index - this.visibleItems + 1;
				} else if (index < this.currentPosition) {
					this.currentPosition = index;
				}
			},
			slideLeft() {
				if (!this.isAtEnd) {
					this.currentPosition += this.visibleItems;
					if (this.currentPosition > this.images.length - this.visibleItems) {
						this.currentPosition = this.images.length - this.visibleItems;
					}
				}
			},
			slideRight() {
				if (!this.isAtStart) {
					this.currentPosition -= this.visibleItems;
					if (this.currentPosition < 0) {
						this.currentPosition = 0;
					}
				}
			},
			startDrag(e) {
				this.isDragging = true;
				let key = this.isMobile ? 'clientY' : 'clientX'
				this.startX = e[key] || e.touches[0][key];
				this.lastDragOffset = 0;
				this.velocity = 0;
				this.lastTime = Date.now();
				cancelAnimationFrame(this.animationId);
			},
			onDrag(e) {
				if (!this.isDragging) return;
				
				let key = this.isMobile ? 'clientY' : 'clientX'
				const x = e[key] || e.touches[0][key];
				const now = Date.now();
				const deltaTime = now - this.lastTime;

				this.dragOffset = x - this.startX;

				if (deltaTime > 0) {
					this.velocity = (this.dragOffset - this.lastDragOffset) / deltaTime;
					this.lastDragOffset = this.dragOffset;
					this.lastTime = now;
				}

				e.preventDefault();
			},

			endDrag() {
				if (!this.isDragging) return;
				this.isDragging = false;

				// 计算惯性滑动距离（减小惯性效果）
				const momentumDistance = this.velocity * 50;
				const totalOffset = this.dragOffset + momentumDistance;

				// 计算应该移动的图片数量（四舍五入）
				const itemDelta = Math.round(totalOffset / this.itemWidth);

				// 计算新位置（限制在合理范围内）
				let newPosition = this.currentPosition - itemDelta;
				newPosition = Math.max(0, Math.min(newPosition, this.images.length - this.visibleItems));

				// 直接设置新位置，不使用动画过渡
				this.currentPosition = newPosition;
				this.dragOffset = 0;

				// 重置速度相关变量
				this.velocity = 0;
				this.lastDragOffset = 0;
			},
			easeOutCubic(t) {
				return 1 - Math.pow(1 - t, 3);
			},
			openLightbox(index) {
				this.lightboxIndex = index;
				this.activeIndex = index; // 打开时也同步选中状态
				this.showLightbox = true;
				document.body.style.overflow = 'hidden';

				// 确保主轮播图滚动到正确位置
				if (index > this.currentPosition + this.visibleItems - 1) {
					this.currentPosition = index - this.visibleItems + 1;
				} else if (index < this.currentPosition) {
					this.currentPosition = index;
				}
			},
			closeLightbox() {
				this.showLightbox = false;
				document.body.style.overflow = ''; // 恢复背景滚动
			},
			prevImage() {
				if (this.lightboxIndex > 0) {
					this.lightboxIndex--;
					this.syncMainCarousel();
				}
			},
			nextImage() {
				if (this.lightboxIndex < this.images.length - 1) {
					this.lightboxIndex++;
					this.syncMainCarousel();
				}
			},
			// 新增方法：同步主轮播图状态
			syncMainCarousel() {
				this.activeIndex = this.lightboxIndex;

				// 确保主轮播图滚动到正确位置
				if (this.activeIndex > this.currentPosition + this.visibleItems - 3) {
					this.currentPosition = this.activeIndex - this.visibleItems + 3;
				} else if (this.activeIndex < this.currentPosition) {
					this.currentPosition = this.activeIndex;
				}
			},
			handleKeydown(e) {
				if (!this.showLightbox) return;
				if (e.key === 'Escape') {
					this.closeLightbox();
				} else if (e.key === 'ArrowLeft') {
					this.prevImage();
				} else if (e.key === 'ArrowRight') {
					this.nextImage();
				}
			},
		},

	};
</script>

<style lang="less" scoped>
	.pic {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		background: #ffffff;
		width: 100%;
		overflow: hidden;
		line-height: 66px;
		letter-spacing: 0;
		color: #ffffff;
		font-family: Inter;
		font-size: 54px;
		font-weight: 700;
		height: 100vh;
	}

	.frame {
		max-width: 80%;
		max-height: 90%;
		// border-radius: 20px;
		cursor: zoom-in;
		box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);
	}

	.auto-wrapper {
		position: relative;
		margin-right: 6vw;
		width: 40%;
		height: 100vh;
	}

	.frame-2 {
		display: flex;
		position: absolute;
		bottom: 0;
		left: 0;
		justify-content: start;
		width: calc(100% - 10.2vw);
		height: 25vh;
		padding: 0 5.1vw;
		background: #055264;
		overflow: hidden;
		align-items: center;
		user-select: none;

		.carousel-track {
			display: flex;
			transition: transform 0.3s ease-out;
			will-change: transform;
			cursor: grab;
			height: 100%;

			&.grabbing {
				cursor: grabbing;
				transition: none;
			}
		}

		.img-block {
			margin: 20px 15px;
			display: flex;
			align-items: start;
			cursor: pointer;
			transition: all 0.3s ease;
			flex-shrink: 0;
			overflow: hidden;
			width: 200px;
			border-radius: 3px;
			background: rgba(255, 255, 255, 0.2);
      height: 80%;
      position: relative;

			img {
				// min-width: 100%;
				min-height: 100%;
				width: 100%;
				// height: 100%;
				overflow: hidden;
				transition: all 0.3s ease;
				pointer-events: none;
				cursor: zoom-in;
				object-fit: cover;
        // position: absolute;
        // width: auto;
        // top: 0;
        // left: 50%;
        // transform: translateX(-50%); /* 补偿定位偏移 */
			}

			&.active{
				transform: scale(1.1);
				box-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
				border: 2px solid #ffffff;
			}
		}
	}

	.frame-6 {
		display: flex;
		position: absolute;
		top: 0;
		left: 0;
		flex-direction: column;
		align-items: center;
		width: 40vw;
	}

	.frame-7 {
		display: flex;
		align-items: flex-start;
		background: #ee99b4;
		width: 100%;
		height: 75vh;
		align-items: center;
		position: relative;
	}

	.frame-8 {
		width: 70%;
		margin: 0 auto;
		display: flex;
	}

	.frame-9 {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		padding: 0 60px 0 5vw;
		width: calc(100% - 60px - 5vw);
		background: #de5c7f;
		height: 25vh;
		align-items: center;
	}

	.frame-10 {
		width: 108px;
		height: 66px;
	}

	.frame-11 {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		width: 140px;
	}

	.auto-wrapper-2 {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}

	.text {
		margin: 0px 0px 0px 25px;
		min-width: 70px;
		line-height: 100px;
		font-size: 70px;
	}

	.d-esign {
		margin: -8px 0px 0px;
		min-width: 90px;
		line-height: 35px;
		font-size: 20px;
		text-align: right;
	}

	.text-2 {
		margin: 70px 0px 0px;
		min-width: 35px;
		font-size: 40px;
	}

	.img-body {
		width: calc(60% - 110px);
		height: 75vh;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.auto-wrapper-1 {
		position: relative;
		width: 66px;
		height: 59px;
		display: inline-flex;
	}

	.polygon {
		margin: 0 10px;
		cursor: pointer;
		transition: opacity 0.3s ease;

		&:hover:not(.disabled) {
			opacity: 0.5;
		}

		&.disabled {
			opacity: 0.3;
			cursor: not-allowed;
		}
	}

	.polygon-1 {}

	.polygon-2 {
		transform: rotate(180deg);
	}

	/* 全屏图片查看器样式 */
	.lightbox {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.9);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
		cursor: zoom-out;
		backdrop-filter: blur(5px);
	}

	.lightbox-content {
		position: relative;
		width: 85%;
		// max-height: 90%;
		height: inherit;
		display: flex;
		justify-content: center;
		align-items: start;
		overflow: auto;
		// background: rgba(255, 255, 255, 1);
		backdrop-filter: blur(5px);
	}
	.lightbox-tip{
		position: absolute;
		color: #fff;
		bottom: 5px;
		font-size: 10px;
		z-index: 1000;
		opacity: 0.4;
		width: 12%;
		line-height: 17px;
		right: 0.2%;
		text-align: center;
		
		div{
			margin-bottom: 15px;
		}
	}

	.lightbox-image {
		width: 100%;
		// max-height: 90vh;
		object-fit: contain;
		cursor: default;
		// border-radius: 30px;
		margin: 40px 0;
	}

	.lightbox-close {
		position: fixed;
		/* 改为fixed定位 */
		top: 20px;
		right: 20px;
		background: none;
		border: none;
		color: white;
		font-size: 40px;
		cursor: pointer;
		z-index: 1001;
		padding: 10px 20px;

		&:hover {
			opacity: 0.8;
		}
	}

	.lightbox-nav {
		position: fixed;
		/* 改为fixed定位 */
		top: 50%;
		transform: translateY(-50%);
		background: rgba(0, 0, 0, 0.5);
		border: none;
		color: white;
		font-size: 30px;
		width: 60px;
		height: 60px;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		z-index: 1001;

		&:hover {
			background: rgba(0, 0, 0, 0.8);
		}

		&[disabled] {
			opacity: 0.3;
			cursor: not-allowed;
		}
	}


	.lightbox-prev {
		left: 20px;

		.nav-arrow {
			transform: rotate(0deg);
		}
	}

	.lightbox-next {
		right: 20px;

		.nav-arrow {
			transform: rotate(180deg);
		}
	}

	.nav-arrow {
		width: 30px;
		height: 30px;
	}
	
	.fixed-btn{
		position: absolute;
		top: 20px;
		right: 20px;
		background: rgba(255, 255, 255, 0.2);
	}
	@media screen and (max-width: 1440px) {
		.frame-2 .img-block img{
			max-height: 260%;
		}
	}
	@media screen and (max-width: 1367px) {
		
	}
	/* 手机端强制横屏 */
	@media screen and (orientation:portrait) {
		.pic {
			width: 100vh;
			height: 100vw;
			overflow-y: hidden;
			transform-origin: 0 0;
			transform: rotateZ(90deg) translateY(-100%);
		}

		.lightbox {
			transform: rotate(0deg) translateY(0);
			transform-origin: 0 0;
			width: 100vh;
			height: 100vw;
		}
		.frame-2{
			height: 25vw;
		}
		.frame-6{
			width: 40vh;
		}
		.frame-7{
			height: 75vw;
		}
		.frame-9{
			height: 25vw;
			padding: 0 30px 0 30px;
			width: calc(100% - 60px);
		}
		.img-body{
			height: 75vw;
			width: 60%;
		}
		.frame{
			max-width: 90%;
			max-height: 90%;
		}
		.auto-wrapper-1{
			height: 35px;
		}
		.polygon{
			width: 40px;
		}
		.text{
			font-size: 40px;
			line-height: 50px;
			text-align: right;
			margin-top: 15px;
			margin-left: 30px;
		}
		.d-esign{
			font-size: 15px;
			min-width: 97px;
		}
		.text-2{
			font-size: 30px;
			margin-top: 40px;
		}
		.lightbox-content{
			width: 75%;
		}
		.lightbox-image{
			margin: 20px 0;
		}
    .frame-2 .img-block {
    	justify-content: center;
			// align-items: start;
      background: rgba(255, 255, 255, 0.2);
      height: 65%;
      width: 100px;
      margin: 20px 10px;

    	img {
    		// max-width: 100%;
        min-width: 40%;
    		max-height: 280%;
        position: relative;
        transform: translateX(0);
        left: 0;
    	}
    }
	
	.auto-wrapper{
		transform: translateZ(0);
	}
}
	// 适配手机端非全屏浏览器(页面高度更短)
	@media screen and (min-height: 600px) and (max-height: 680px) and (max-width: 768px) {
		// .carousel-track{
		// 	position: relative;
		// 	  isolation: isolate; /* 隔离层叠上下文 */
		// }
		.auto-wrapper-1 img{
			width: 25px;
		}
		.frame-9{
			// padding-left: 3vw;
			// width: calc(100% - 60px - 1vw);
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/pic/pic.vue